import React from "react";
import Chip from "@material-ui/core/Chip";
import { i18n } from "../../translate/i18n";
import { getStatusColor, getPriorityColor } from "../../pages/Tasks/taskUtils";

export const TaskStatusChip = ({ status, size = "small" }) => {
  const { background, color } = getStatusColor(status);

  return (
    <Chip
      label={i18n.t(`tasks.status.${status}`)}
      size={size}
      style={{ backgroundColor: background, color, fontWeight: 500 }}
    />
  );
};

export const TaskPriorityChip = ({ priority, size = "small" }) => {
  const { background, color } = getPriorityColor(priority);

  return (
    <Chip
      label={i18n.t(`tasks.priority.${priority}`)}
      size={size}
      style={{ backgroundColor: background, color, fontWeight: 500 }}
    />
  );
};

export const TaskTypeChip = ({ type, size = "small" }) => (
  <Chip label={i18n.t(`tasks.type.${type}`)} size={size} variant="outlined" />
);
